export const languageOptions = [
  { code: 'zh-CN', label: '中文' },
  { code: 'en-US', label: 'English' },
  { code: 'ja-JP', label: '日本語' },
  { code: 'ko-KR', label: '한국어' },
]

export const getLanguageOption = (code) =>
  languageOptions.find((option) => option.code === code)
